import { Injectable, ViewContainerRef } from '@angular/core';

import { UserService } from '../../user/user.service';
import { SettingsEntry } from './settings-entry';

@Injectable()
export class LogOutEntry implements SettingsEntry {
    label: string;
    userService: UserService;

    constructor(usrService: UserService) {
        this.userService = usrService;
        this.label = 'Logout';
    }

    activate(viewContainerRef: ViewContainerRef) {
        this.userService.logOut();
    }

    clean() { }

}



// WEBPACK FOOTER //
// ./src/app/headerfooter/setting-entries/logout-entry.ts